import React from 'react';
import { Check, BookOpen, ShoppingCart, ShieldAlert } from 'lucide-react';
export function FeaturesSection() {
  const features = [{
    icon: BookOpen,
    title: 'Ebook completo',
    desc: 'Guía paso a paso con recetas low-tox organizadas por zonas de la casa.'
  }, {
    icon: ShoppingCart,
    title: 'Lista de compras Rutina Low-Tox',
    desc: 'Lista completa de productos recomendados para implementar tu rutina sin complicaciones.'
  }, {
    icon: ShieldAlert,
    title: 'Guía de Brotes (48h)',
    desc: 'Protocolo de emergencia: qué pausar primero cuando los síntomas aparecen.'
  }];
  return <section className="py-16 md:py-24 bg-white" data-id="element-31">
      <div className="container mx-auto px-4 md:px-6" data-id="element-32">
        <div className="flex flex-col lg:flex-row gap-16 items-center" data-id="element-33">
          <div className="flex-1" data-id="element-34">
            <h2 className="text-3xl md:text-4xl font-bold text-[#44403C] mb-8" data-id="element-35">
              Todo lo que necesitas para recuperar el control de tu hogar
            </h2>

            <div className="space-y-8" data-id="element-36">
              {features.map((feature, i) => <div key={i} className="flex gap-4" data-id="element-37">
                  <div className="w-10 h-10 rounded-full bg-[#FAF8F5] flex items-center justify-center flex-shrink-0 text-[#C97D60]" data-id="element-38">
                    <feature.icon className="w-5 h-5" data-id="element-39" />
                  </div>
                  <div data-id="element-40">
                    <h3 className="text-lg font-bold text-[#44403C] mb-1" data-id="element-41">
                      {feature.title}
                    </h3>
                    <p className="text-[#57534E]" data-id="element-42">{feature.desc}</p>
                  </div>
                </div>)}
            </div>

            <div className="mt-10 p-6 bg-[#E8F0E6]/50 rounded-xl border border-[#8B9D83]/20" data-id="element-43">
              <h4 className="font-bold text-[#44403C] mb-2 flex items-center gap-2" data-id="element-44">
                <Check className="w-5 h-5 text-[#8B9D83]" data-id="element-45" />
                Política de Seguridad
              </h4>
              <p className="text-sm text-[#57534E]" data-id="element-46">
                Todas las recetas son <strong data-id="element-47">sin fragancia añadida</strong>.
                Los aceites esenciales son marcados como{' '}
                <strong data-id="element-48">opcionales</strong> y con precauciones claras.
              </p>
            </div>
          </div>

          <div className="flex-1 w-full" data-id="element-49">
            <div className="bg-[#FAF8F5] p-8 md:p-12 rounded-3xl border border-[#EBE5DE] relative" data-id="element-50">
              <div className="absolute -top-6 -right-6 w-24 h-24 bg-[#C97D60] rounded-full opacity-10 blur-2xl" data-id="element-51"></div>
              <h3 className="text-2xl font-bold text-[#44403C] mb-6 text-center" data-id="element-52">
                Si vives en USA y tu casa es bilingüe… tu limpieza también
                necesita serlo.
              </h3>
              <div className="space-y-4" data-id="element-53">
                <div className="bg-white p-4 rounded-lg shadow-sm flex items-center justify-between" data-id="element-54">
                  <span className="text-[#57534E] font-medium" data-id="element-55">
                    Kitchen Checklist
                  </span>
                  <span className="text-[#8B9D83] font-bold" data-id="element-56">EN</span>
                </div>
                <div className="bg-white p-4 rounded-lg shadow-sm flex items-center justify-between" data-id="element-57">
                  <span className="text-[#57534E] font-medium" data-id="element-58">
                    Lista de Cocina
                  </span>
                  <span className="text-[#C97D60] font-bold" data-id="element-59">ES</span>
                </div>
                <div className="bg-white p-4 rounded-lg shadow-sm flex items-center justify-between" data-id="element-60">
                  <span className="text-[#57534E] font-medium" data-id="element-61">
                    Laundry Reset Guide
                  </span>
                  <span className="text-[#8B9D83] font-bold" data-id="element-62">EN</span>
                </div>
                <div className="bg-white p-4 rounded-lg shadow-sm flex items-center justify-between" data-id="element-63">
                  <span className="text-[#57534E] font-medium" data-id="element-64">
                    Guía de Lavandería
                  </span>
                  <span className="text-[#C97D60] font-bold" data-id="element-65">ES</span>
                </div>
              </div>
              <p className="text-center text-sm text-[#78716C] mt-6 italic" data-id="element-66">
                Perfecto para compartir con helpers, niñeras o familiares que no
                hablan español.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}